export default __webpack_public_path__ + "static/media/detail_big_1_3.aca4cd6f.png";